import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class VehicleType extends Enum {
  static PASSENGER_CARS = {
    key: 'passenger_cars',
    get value() {
      return Lang.t('asset.passenger-cars');
    },
    get description() {
      return Lang.t('asset.automobiles-suvs-minivans');
    }
  };

  static RECREATIONAL_VEHICLES = {
    key: 'recreational_vehicles',
    get value() {
      return Lang.t('asset.recreational-vehicles');
    },
    get description() {
      return Lang.t('asset.towable-or-motorized');
    }
  };

  static RECREATIONAL_PRODUCTS = {
    key: 'recreational_products',
    get value() {
      return Lang.t('asset.recreational-products');
    },
    get description() {
      return Lang.t('asset.motorcycles-atvs-jet');
    }
  };
}
